import React, { Component } from 'react'
import TeamMemberRow from './team_member_row'

class TeamInviteList extends Component {
    render() {
        const { teamInvites, reportUser, deleteInvite, handleDisableMember } = this.props
        return (
            <div>
                <div className="team-invite-list">
                    {teamInvites.map((tm)=>
                        <TeamMemberRow 
                            key={tm.id}
                            teamMember={{id: tm.id, primaryEmail: tm.invitedEmail}}
                            reportUser={reportUser}
                            deleteInvite={deleteInvite}
                            canEditMembership={true}
                            canRemoveMembership={true}
                            handleDisableMember={handleDisableMember}
                            isInvitedMember={true}
                        />)}
                </div>
            </div>
        )
    }

}

export default TeamInviteList


// WEBPACK FOOTER //
// ./src/components/team_invite_list.jsx